import { Component, Input } from '@angular/core';
import { Cluster } from '../../../shared';

@Component({
  selector: 'app-map-il',
  templateUrl: './map-il.component.html',
  styleUrls: ['./map-il.component.css', '../../map.css']
})
export class MapILComponent{
  @Input() cluster: Cluster;
}



// WEBPACK FOOTER //
// ./src/app/map/components/map-il/map-il.component.ts